<template>
    <div>
        <loading-progress
                :indeterminate="loading"
                :hideBackground="true"
                shape="line"
                :size="windowWidth"
                :width="windowWidth"
                height="6"
        />

        <div class="container">
            <div id="nav-bar">
                <vue-form-generator v-if="fuel && capabilities.switch_carburante" :schema="schema" :model="filters" :options="formOptions" id="fuel-select"></vue-form-generator>
                <div id="nav-buttons">
                    <button v-if="fuel && capabilities.calc_itinerario" v-on:click="showPanel('MapRoute','right')" class="nav-separator">
                        <table>
                            <tr>
                                <td><img src="../assets/nav-up-route.png" /></td>
                                <td><span>Calcola itinerario</span></td>
                            </tr>
                        </table>
                    </button>
                    <button v-if="fuel" v-on:click="showPanel('MapSearch','right')" class="nav-separator">
                        <table>
                            <tr>
                                <td><img src="../assets/nav-up-search.png" /></td>
                                <td><span>Cerca Filtra</span></td>
                            </tr>
                        </table>
                    </button>
                    <button v-if="fuel && country && capabilities.poi_pdi" v-on:click="showPanel('MapPoi','right')" class="nav-separator">
                        <table>
                            <tr>
                                <td><img src="../assets/nav-up-poi.png" /></td>
                                <td><span>POI/PDI</span></td>
                            </tr>
                        </table>
                    </button>
                    <button v-if="fuel && capabilities.selezione_nazione" v-on:click="showPanel('MapCountries','right')">
                        <table>
                            <tr>
                                <td><img src="../assets/nav-up-countries.png" /></td>
                                <td><span>Seleziona nazione</span></td>
                            </tr>
                        </table>
                    </button>
                </div>
            </div>
        </div>

        <div style="position:relative">
            <div class="side-bar">
                <button v-if="capabilities.invia_segnalazione" v-on:click="showPanel('MapAdd','left')">
                    <img src="../assets/nav-alert.png" />
                    <span>Invia Segnalazione</span>
                </button>
                <button v-if="country && capabilities.statistiche" v-on:click="showPanel('MapStats','left')">
                    <img src="../assets/nav-stats.png" />
                    <span>Statistiche</span>
                    <span class="country-label">{{ (city) ? city.name : (state) ? state.name : country.value }}</span>
                </button>
                <button v-if="country && capabilities.prezzi" v-on:click="showPanel('MapPrices','left')">
                    <img src="../assets/nav-prices.png" />
                    <span>Prezzi</span>
                    <span class="country-label">{{ (city) ? city.name : (state) ? state.name : country.value }}</span>
                </button>
                <button v-if="country && capabilities.aggiornamenti" v-on:click="showPanel('MapNews','left')">
                    <img src="../assets/nav-news.png" />
                    <span>Aggiornamenti</span>
                    <span class="country-label">{{ country.value }}</span>
                </button>
            </div>
            <slideout-panel></slideout-panel>

            <GmapMap id="eco-map"
                     :center=center
                     :zoom=zoom
                     map-type-id="roadmap"
                     ref="ecoMap"
                     :options="mapOptions"
                     :style="'width: 100%; height: ' + mapHeight + 'px;'"
            >
                <GmapInfoWindow
                                @closeclick="openWind=false"
                                :opened=openWind
                                :position=infoPos
                                :options=optionsInfoWindow
                >
                    <div class="marker-info">
                        <p class="country-title" v-if="distID.value">{{ distID.value }}</p>
                        <p class="country-address" v-if="distID.address">{{ distID.address }}</p>
                        <table>
                            <tr v-if="distID.stations" class="station">
                                <td>Distributori</td>
                                <td class="value">{{ distID.stations.open + distID.stations.closed }}</td>
                            </tr>
                            <tr v-if="distID.price && distID.chiuso!=1" class="price">
                                <td>Prezzo</td>
                                <td class="value">{{ distID.price }}</td>
                            </tr>
                            <tr v-if="distID.chiuso==1" class="price">
                                <td class="value" style="text-align: center">Chiuso</td>
                            </tr>
                        </table>
                        <button v-on:click="goToRoute()">Visualizza</button>
                    </div>
                </GmapInfoWindow>
                <gmap-custom-marker
                        v-for="(m, index) in markers"
                        :marker="m.position"
                        @click.native="showInfoWindow(m)"
                    >
                    <div :style="m.style" :class="'marker ' + m.type">
                        <p v-if="m.type=='region' || m.type=='province'">{{ (fuel == 1 || fuel == 8) ? 'M' : (fuel == 4) ? 'G' : (fuel == 7) ? 'LNG' : 'E' }}</p>
                        <p class="station-logo" v-if="m.type=='station'" :style="m.logo"></p>
                        <p v-if="m.type=='waypoint'">{{ m.label }}</p>
                    </div>
                </gmap-custom-marker>
            </GmapMap>

            <div class="poweredby" v-if="capabilities.poweredby">
                <div>
                    <a href="https://ecomotori.net" target="_blank"><img src="https://www.ecomotori.net/wp-content/themes/ecomotori/img/powered_by_orizzontale.png" /></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from "vue";
import { gmapApi } from "vue2-google-maps";
import Api from "../api";
import GmapCustomMarker from 'vue2-gmap-custom-marker';
import * as VueGoogleMaps from 'vue2-google-maps'

import { serverBus } from '../main';
import Countries from '../models/countries';
import Regions from '../models/regions';
import Fuels from '../models/fuels';
import Levels from '../models/zoomlevels';
import Provinces from '../models/provinces';

import MapDetail from '../views/MapDetail.vue'
import MapCountries from '../views/CountriesList.vue'
import MapRoute from '../views/MapRoute.vue'
import MapAdd from '../views/MapAdd.vue'
import MapNews from '../views/MapNews.vue'
import MapStats from '../views/MapStats.vue'
import MapPrices from '../views/MapPrices.vue'
import MapSearch from '../views/MapSearch.vue'
import MapPoi from '../views/MapPDI.vue'
import MapFuels from '../views/FuelList.vue'
import VueFormGenerator from "vue-form-generator";

Vue.component("MapDetail", {
    name: "MapDetail",
    render: h => h(MapDetail)
});

Vue.component("MapCountries", {
    name: "MapCountries",
    render: h => h(MapCountries)
});

Vue.component("MapRoute", {
    name: "MapRoute",
    render: h => h(MapRoute)
});

Vue.component("MapAdd", {
    name: "MapAdd",
    render: h => h(MapAdd)
});

Vue.component("MapNews", {
    name: "MapNews",
    render: h => h(MapNews)
});

Vue.component("MapStats", {
    name: "MapStats",
    render: h => h(MapStats)
});

Vue.component("MapPrices", {
    name: "MapPrices",
    render: h => h(MapPrices)
});

Vue.component("MapSearch", {
    name: "MapSearch",
    render: h => h(MapSearch)
});

Vue.component("MapPoi", {
    name: "MapPoi",
    render: h => h(MapPoi)
});

Vue.component("MapFuels", {
    name: "MapFuels",
    render: h => h(MapFuels)
});

Vue.use(VueGoogleMaps);

export default {
    name: "home",
    components: {
        'GmapCustomMarker': GmapCustomMarker,
        "vue-form-generator": VueFormGenerator.component
    },
    filters: {
        first_letter: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase()
        }
    },
    methods: {
        closePanel: function () {
          serverBus.$emit('pageChanged','Map');
            if(this.activePanel) {
                this.activePanel.hide();
                this.activePanel = null;
                this.selectDistID = null;
            }
        },
        formatMarker(_dist) {
            return {
                id: _dist.iddistributore,
                location: {
                    country: { id: _dist.idstato, name: _dist.stato},
                    state: { id: _dist.idregione, name: _dist.regione},
                    city: { id: _dist.idprovincia, name: _dist.provincia},
                },
                type: 'station',
                position: {
                    lat: Number.parseFloat(_dist.latitudine),
                    lng: Number.parseFloat(_dist.longitudine)
                },
                color: (_dist.autostradale == "1") ? 'green' : (_dist.idcarburante == 1 || _dist.idcarburante == 8) ? 'lightblue' : (_dist.idcarburante == 4) ? 'red' : (_dist.idcarburante == 7) ? 'blue' : 'yellow',
                code: _dist.codice,
                value: _dist.comune + ' (' + _dist.codice + ')',
                name: _dist.comune,
                address: _dist.indirizzo,
                price: _dist.costo + _dist.valuta,
                chiuso: _dist.chiuso,
                style: {
                    "background-image": "url('" + require('../assets/pins/bgs/' + ((_dist.autostradale == "1") ? 'autostradale' : (_dist.idcarburante == 1 || _dist.idcarburante == 8) ? 'metano' : (_dist.idcarburante == 4) ? 'gpl' : (_dist.idcarburante == 7) ? 'lpg' : 'elettriche') + '.png' ) + "')"
                },
                label: (_dist.idcarburante == 1 || _dist.idcarburante == 8) ? 'M' : (_dist.idcarburante == 4) ? 'G' : (_dist.idcarburante == 7) ? 'ML' : 'E',
                logo: {
                    "background-image": "url('" + ((_dist.bandiera) ? "https://forum.ecomotori.net/distributori/" + _dist.bandiera  : require('../assets/flags/empty.jpg')) + "')"
                },
                path: [
                    '/distributori',
                    Fuels.getById(this.fuel).slug,
                    _dist.stato.replace(' ','+'),
                    _dist.regione.replace(' ','+'),
                    _dist.provincia.replace(' ','+'),
                    [
                        _dist.iddistributore,
                        _dist.codice,
                        [
                            _dist.insegna,
                            _dist.comune,
                            _dist.indirizzo.replace('/',' ')
                        ].join('-')
                    ].join('-')
                ].join('/').trim().replace(/ /g, '+')
            }
        },
        onInitedMap: function (map) {
            this.gmapInstance = map;
            this._debouncing = null;
            this.windowWidth = window.innerWidth;
            this.mapHeight = window.innerHeight - 60;

            const $scope = this;

            this.getFuelIdFromRoute();
            this.getRoute();

            // Listen to changing map limits:
            this.google.maps.event.addListener(
                this.gmapInstance,
                "bounds_changed",
                this.boundsChanged
            );

            window.addEventListener('resize', function() {
                $scope.windowWidth = window.innerWidth;
            });

            if(!this.fuel) {
              $scope.showPanel('MapFuels','right');
            }

            /*if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    this.getUserPositionSuccess,
                    this.getUserPositionError
                );
            }*/

        },
        checkCurrentLocation(_zoom) {
            var $scope = this;

            var _currentZoom = $scope.gmapInstance.zoom;

            if(_currentZoom && !$scope.selectDistID) {

                $scope.loading = true;

                Api.getGeocode($scope.gmapInstance.getCenter().lat(), $scope.gmapInstance.getCenter().lng(), function (err, _position) {
                    if (!err) {
                        $scope.last_geo_info = _position;
                        Countries.getById(parseInt(_position.codice_stato), $scope.fuel, $scope.filters,function (_country) {
                            $scope.country = _country;
                            $scope.state = null;
                            $scope.city = null;

                            switch (Levels.getByZoom(_currentZoom,$scope.filters).name) {
                                case Levels.country:
                                    $scope.updateBrowserUrl();
                                    $scope.markers = [];
                                    $scope.loadCountries();
                                    break;
                                case Levels.region:
                                    $scope.updateBrowserUrl(_position.stato);
                                    $scope.markers = [];
                                    $scope.loadRegions();
                                    break;
                                case Levels.province:
                                    $scope.updateBrowserUrl(_position.stato,_position.regione);
                                    if (_position.codice_regione) $scope.state = {
                                        id: _position.codice_regione,
                                        name: _position.regione
                                    };
                                    $scope.markers = [];
                                    $scope.loadProvinces();
                                    break;
                                case Levels.city:
                                    $scope.updateBrowserUrl(_position.stato,_position.regione,_position.provincia);
                                    if (_position.codice_regione) $scope.state = {
                                        id: _position.codice_regione,
                                        name: _position.regione
                                    };
                                    if (_position.codice_provincia) $scope.city = {
                                        id: _position.codice_provincia,
                                        name: _position.provincia
                                    };
                                    $scope.getKmRangeByMapZoomCoverage(function (err) {
                                        if (err) return $scope.loading = false;

                                        $scope.markers = [];

                                        Api.getStations({
                                            lat: $scope.gmapInstance.getCenter().lat(),
                                            lng: $scope.gmapInstance.getCenter().lng()
                                        }, $scope.fuel, $scope.range, $scope.filters, false, function (err, res) {
                                            for (let key in res.distributori) {
                                                if (res.distributori.hasOwnProperty(key)) {
                                                    let _dist = res.distributori[key];
                                                    let _formatted_dist = $scope.formatMarker(_dist);

                                                    $scope.markers.push(_formatted_dist);

                                                    if(typeof $scope.openDistID != 'undefined' && $scope.openDistID == _formatted_dist.id) {
                                                        $scope.openDistID = false;
                                                        $scope.distID = _formatted_dist;

                                                        $scope.showPanel('MapDetail','right');
                                                        $scope.updateBrowserUrl(_position.stato,_position.regione,_position.provincia,$scope.distID);
                                                    }
                                                }
                                            }
                                            $scope.loading = false;
                                        });
                                    });
                                    break;
                            }

                            // broadcast zone changed
                            serverBus.$emit('areaChanged', {
                                country: $scope.country,
                                state: $scope.state,
                                city: $scope.city
                            })
                        });

                    }

                });
            }
        },
        loadCountries: function() {
            var $scope = this;
            $scope.loading = true;
            $scope.country = null;

            Countries.getMarkers($scope.fuel,$scope.filters,function(_markers){
                $scope.markers = _markers;
                $scope.loading = false;
            });
        },
        loadRegions: function() {
            var $scope = this;
            $scope.loading = true;

            this.getKmRangeByMapZoomCoverage(function (err) {
                if(err) return $scope.loading = false;

                Regions.getMarkers({
                    lat: $scope.gmapInstance.getCenter().lat(),
                    lng: $scope.gmapInstance.getCenter().lng()
                }, $scope.fuel, $scope.range, $scope.filters,function (_markers) {
                    $scope.markers = _markers;
                    $scope.loading = false;
                });
            });
        },
        loadProvinces: function() {
            var $scope = this;
            $scope.loading = true;

            this.getKmRangeByMapZoomCoverage(function (err) {
                if(err) return $scope.loading = false;

                Provinces.getMarkers({
                    lat: $scope.gmapInstance.getCenter().lat(),
                    lng: $scope.gmapInstance.getCenter().lng()
                }, $scope.fuel, $scope.range, $scope.filters,function (_markers) {
                    $scope.markers = _markers;
                    $scope.loading = false;
                });
            });
        },
        boundsChanged: function() {
            const $scope = this;

            if(!this.polyline) {
                clearTimeout($scope._debouncing)
                $scope._debouncing = setTimeout(function () {
                    $scope.checkCurrentLocation.apply($scope)
                    serverBus.$emit("boundsChanged");
                }, 1000)
            }
        },
        getKmRangeByMapZoomCoverage: function (callback) {
            var map = this.gmapInstance;

            var bounds = map.getBounds();
            var center = map.getCenter();

            if (bounds && center) {
                var ne = bounds.getNorthEast();

                // Calculate radius (in meters).
                let km = google.maps.geometry.spherical.computeDistanceBetween(center, bounds.getNorthEast())/1000;
                let slide = 99

                if(this.lastCenter) slide = google.maps.geometry.spherical.computeDistanceBetween(center, this.lastCenter)/1000;

                if(Math.abs(km-this.range) > 5 || slide > 5 || this.markers.length == 0 || this.lastFuel != this.fuel || this.lastFilters != JSON.stringify(this.filters)) {
                    this.range = km;
                    this.lastCenter = center;
                    this.lastFuel = this.fuel;
                    this.lastFilters = JSON.stringify(this.filters);
                    callback();
                } else {
                    callback(true);
                }
            } else {
                callback(true);
            }
        },
        getFuelIdFromRoute: function () {
            if(this.$route.params.fuel) this.fuel = Fuels.getBySlug(this.$route.params.fuel).id;
            this.filters.fuel = this.fuel;
        },
        getRoute: function () {
            const $scope = this;

            var _p = this.$route.params;

            if(_p.station_slug) {
                var _dist_id = _p.station_slug.split('-')[0];
                Api.getStation(_dist_id, $scope.fuel, function(err,_station){
                    $scope.$refs.ecoMap.$mapPromise.then((map) => {
                        map.panTo({
                            lat: Number.parseFloat(_station.latitudine),
                            lng: Number.parseFloat(_station.longitudine)
                        });
                        map.setZoom(14);
                    })

                    $scope.openDistID = Number.parseInt(_dist_id);
                    console.log('Moving to station...');
                });
            } else if(_p.province) {
                Provinces.get(_p.country.replace('+',' '), _p.region.replace('+',' '), _p.province.replace('+',' '), $scope.fuel, function (_province) {
                    $scope.$refs.ecoMap.$mapPromise.then((map) => {
                        map.panTo({
                            lat: Number.parseFloat(_province.position.lat),
                            lng: Number.parseFloat(_province.position.lng)
                        });
                        map.setZoom(Levels.getNextZoom('province'));
                    })

                    console.log('Moving to provice...');
                });
            } else if(_p.region) {
                Regions.get(_p.country.replace('+',' '), _p.region.replace('+',' '), $scope.fuel, function (_region) {
                    $scope.$refs.ecoMap.$mapPromise.then((map) => {
                        map.panTo({
                            lat: Number.parseFloat(_region.position.lat),
                            lng: Number.parseFloat(_region.position.lng)
                        });
                        map.setZoom(Levels.getNextZoom('region'));
                    })

                    console.log('Moving to region...');
                });
            } else if(_p.country) {
              switch (_p.country) {
                case 'Calcolo_Itinerario':
                  this.showPanel('MapRoute','right');
                  break;
                default:
                Countries.get(_p.country.replace('+',' '),$scope.fuel,function(_country){
                    $scope.$refs.ecoMap.$mapPromise.then((map) => {
                        map.panTo({
                            lat: Number.parseFloat(_country.position.lat),
                            lng: Number.parseFloat(_country.position.lng)
                        });
                        map.setZoom(Levels.getNextZoom('country'));
                    })

                    console.log('Moving to country...');
                });
              }

            }
        },
        showPanel: function(template,side) {
            if(this.activePanel) {
                if(this.activePanel._panelOptions.component == template) return;
                this.closePanel();
            }

            if(this.polyline /*&& template != 'MapRoute'*/) {
                this.markers = [];
                if(this.polyline) this.polyline.setMap(null);
                this.polyline = null;
                this.boundsChanged();
            }

            var _newpanel = this.$showPanel({
                component: template,
                width: '480',
                openOn: side,
                disableBgClick: true,
                hideBg: true
            });

            this.activePanel = _newpanel;
        },
        goToFuel: function (fuel) {
            this.fuel = fuel;
            this.checkCurrentLocation();
        },
        goToRoute: function () {
            this.openWind = false;

            if(this.distID.type == 'station') {
                this.center = this.goTo.latLng;
                this.zoom = 14;
                this.showPanel('MapDetail','right');
                this.selectDistID = this.distID;
                this.updateBrowserUrl(
                  this.distID.location.country.name,
                  this.distID.location.state.name,
                  this.distID.location.city.name,
                  this.distID);
            } else {
                serverBus.$emit("goToArea", this.goTo);
            }
        },
        showInfoWindow(m) {
            if(m.type != 'waypoint') {
                this.infoPos = m.position;
                this.openWind = true;
                this.distID = m;
                this.goTo = {
                    latLng: m.position,
                    zoom: parseInt(m.zoom),
                    next_hop: m.next_hop,
                    iso: m.sprite
                }
            }
        },
        updateBrowserUrl(country,region,city,station) {
            if(!this.capabilities.seochangeurl) return;

            if(this.fuel) {
              var _components = ['/map','#',Fuels.getById(this.fuel).slug];
            if(typeof country != 'undefined') _components.push(country.replace(" ","+"));
            if(typeof region != 'undefined') _components.push(region.replace(" ","+"));
            if(typeof city != 'undefined') _components.push(city.replace(" ","+"));

            var _path = _components.join('/');

            if(typeof station != 'undefined') _path = station.path.replace('distributori','map/#');
            if(window.location.pathname+window.location.hash != _path) {
                history.pushState(null, null, _path)
                serverBus.$emit("urlChanged", _path);
            }
          }
        },
        getUrlVars() {
          var vars = {};
          var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
              vars[key] = value;
          });
          return vars;
      }
    },
    data: function () {
        return {
            capabilities: {},
            windowWidth: 200,
            mapHeight: 700,
            gridSize: 100,
            loading: false,
            center: {lat: 50.1502086, lng: 9.8053316},
            lastCenter: false,
            markers: [],
            distID: "",
            distributoriArr: [],
            infoPos: null,
            openWind: false,
            optionsInfoWindow: {
                pixelOffset: {
                    height: -35,
                    width: 0
                }
            },
            mapOptions: {
                disableDefaultUI: true,
                clickableIcons: false
            },
            zoom: 4,
            fuel: null, // 1:metano, 2:gpl
            filters: {
                fuel: null,
                filtro_bestprice: false,
                filtro_selfservice: false,
                filtro_biometano: false,
                filtro_autostradali: false,
                filtro_hiperformance: false,
            },
            country: null,
            state: null,
            city: null,
            range: 50,
            mapCorners: {},
            gmapInstance: null,
            activePanel: null,
            polyline: null,
            last_geo_info: null,
            schema: {
                fields: [{
                    type: "select",
                    model: "fuel",
                    values: function() {
                        return Fuels.getList();
                    },
                    required: true,
                    onChanged: function(model, newVal, oldVal, field) {
                        //this.$parent.$parent.$parent.goToFuel(newVal,(this.$parent.$parent.$parent.country) ? this.$parent.$parent.$parent.country.value : null);
                        serverBus.$emit('fuelChanged',newVal);
                    },
                    selectOptions: {
                        hideNoneSelectedText: true
                    },
                    label: "Seleziona un carburante"
                }]
            },
            formOptions: {
                validateAfterChanged: true
            }
        };
    },
    created() {

        const $scope = this;
        serverBus.$on('capabilitiesUpdated', (capabilities) => {
            $scope.capabilities = capabilities;

            if(typeof ecomotori_key != 'undefined' && ecomotori_key) {
                if(!$scope.fuel && $scope.capabilities.default.carburante > 0) $scope.fuel = $scope.capabilities.default.carburante;
                if(!$scope.country && $scope.capabilities.default.idstato > 0) {
                    console.log('setting default country...');
                    Countries.getById($scope.capabilities.default.idstato,$scope.fuel,$scope.filters,function(_country){
                        VueGoogleMaps.loadGmapApi({
                            key: $scope.capabilities.googleapikey,
                            libraries: 'geometry,places',
                            v: '3.50'
                        });

                        serverBus.$emit('pageChanged', 'Map');

                        serverBus.$emit('positionChanged', {
                            country_iso: _country.sprite
                        });
                    })
                } else {
                    VueGoogleMaps.loadGmapApi({
                        key: $scope.capabilities.googleapikey,
                        libraries: 'geometry,places',
                        v: '3.50'
                    });

                    serverBus.$emit('pageChanged', 'Map');
                }
            } else {
                alert('Ecomotori.net map requires an API key');
            }
        });
        serverBus.$on('loading', (loading) => {
            $scope.loading = loading;
        });
        serverBus.$on('resetRoute', () => {
            $scope.markers = [];
            if($scope.polyline) $scope.polyline.setMap(null);
            $scope.polyline = null;
            $scope.boundsChanged();
        });
        serverBus.$on('closePanel', () => {
            this.closePanel();
        });
        serverBus.$on('goToArea', (_area) => {

            this.closePanel();

            if(_area.next_hop && _area.next_hop == 'country') {
                serverBus.$emit('positionChanged', {
                    country_iso: _area.iso
                });
            } else {
                try {
                    $scope.$refs.ecoMap.$mapPromise.then((map) => {
                        map.panTo(_area.latLng);
                        map.setZoom((_area.next_hop) ? Levels.getNextZoom(_area.next_hop) : _area.zoom);
                    });
                } catch(e) {

                }

            }
        });
        serverBus.$on('goToStation', (_station_id) => {
            var $scope = this;
            this.loading = true;

            Api.getStation(_station_id,this.fuel, function(err,res) {
                if(!err) {
                    $scope.$refs.ecoMap.$mapPromise.then((map) => {
                        map.panTo({
                            lat: parseFloat(res.latitudine),
                            lng: parseFloat(res.longitudine)
                        });
                        map.setZoom(16);
                    })

                    $scope.distID = res;
                    $scope.distID.id = _station_id;

                    $scope.showPanel('MapDetail', 'right');
                    $scope.loading = false;
                } else {
                    $scope.$swal({
                        title: "Distributore non trovato",
                        text: "Il distributore selezionata non è stato trovato",
                        icon: "error",
                        button: "Ok",
                    })
                }
            });
        });
        serverBus.$on('positionChanged', (data) => {
            var $scope = this;

            Countries.getByISOCode(data.country_iso,this.fuel,this.filters,function(_country){
                if(_country) {

                    $scope.country = _country;

                    if(data.latLng) {
                        $scope.$refs.ecoMap.$mapPromise.then((map) => {
                            map.panTo(data.latLng);
                            map.setZoom(Levels.getNextZoom('province'));
                        })
                    } else {
                        if(parseInt(_country.nregioni)==1) {
                            if(parseInt(_country.nprovince)==1) {
                                $scope.$refs.ecoMap.$mapPromise.then((map) => {
                                    map.panTo(new google.maps.LatLng(Number.parseFloat(_country.position.lat), Number.parseFloat(_country.position.lng)));
                                    map.setZoom(Levels.getNextZoom('province'));
                                })
                            } else {
                                $scope.$refs.ecoMap.$mapPromise.then((map) => {
                                  map.panTo(new google.maps.LatLng(Number.parseFloat(_country.position.lat), Number.parseFloat(_country.position.lng)));
                                    map.setZoom(Levels.getNextZoom('region'));
                                })
                            }
                        } else {
                            $scope.$refs.ecoMap.$mapPromise.then((map) => {
                                map.panTo(new google.maps.LatLng(Number.parseFloat(_country.position.lat), Number.parseFloat(_country.position.lng)));
                                map.setZoom(Levels.getNextZoom('country'));
                            })
                        }

                    }

                    $scope.closePanel();
                } else {
                    $scope.$swal({
                        title: "Nazione non gestita",
                        text: "La nazione selezionata non è gestita",
                        icon: "error",
                        button: "Ok",
                    })
                }
            });
        });

        serverBus.$on('changeFilter', (data) => {
          this.selectDistID = null;
          if (data.filter == 'filtro_bestprice'){
            this.filters.filtro_bestprice = data.checked;
          }else if (data.filter == 'filtro_selfservice'){
            this.filters.filtro_selfservice = data.checked;
          }else if (data.filter == 'filtro_biometano'){
            this.filters.filtro_biometano = data.checked;
          }else if (data.filter == 'filtro_autostradali'){
            this.filters.filtro_autostradali = data.checked;
          }else if (data.filter == 'filtro_hiperformance'){
            this.filters.filtro_hiperformance = data.checked;
          }
          this.checkCurrentLocation();
        });

        serverBus.$on('fuelChanged', (fuel) => {
          serverBus.$emit("closePanel");
          this.selectDistID = null;
          this.filters.fuel = fuel;
          this.filters.filtro_bestprice = false;
          this.filters.filtro_selfservice = false;
          this.filters.filtro_biometano = false;
          this.filters.filtro_autostradali = false;
          this.filters.filtro_hiperformance = false;
          this.goToFuel(fuel);
        });

        serverBus.$on('routeCalculated', (res) => {
            if($scope.polyline) $scope.polyline.setMap(null);

            if(res.polyline) {
                $scope.markers = [];

                $scope.polyline = res.polyline;
                $scope.polyline.setMap($scope.gmapInstance);
                $scope.gmapInstance.fitBounds(res.bounds);

                for (var i = 0; i < res.markers.length; i++) {
                    const _dist = res.markers[i];

                    $scope.markers.push($scope.formatMarker(_dist));
                }

                $scope.markers.push({
                    type: 'waypoint',
                    position: {
                        lat: res.start.lat(),
                        lng: res.start.lng()
                    },
                    label: 'P',
                    style: {
                        "background-image": "url('" + require('../assets/pins/bgs/metano.png') + "')"
                    }
                });

                $scope.markers.push({
                    type: 'waypoint',
                    position: {
                        lat: res.end.lat(),
                        lng: res.end.lng()
                    },
                    label: 'A',
                    style: {
                        "background-image": "url('" + require('../assets/pins/bgs/autostradale.png') + "')"
                    }
                });
            } else {
                $scope.polyline = null;
                $scope.checkCurrentLocation();
            }

        });
    },
    computed: {
        google: gmapApi
    },
    watch: {
        distID: function (val) {
            serverBus.$emit('distChanged', val);
        }
    },
    mounted() {
        this.$refs.ecoMap.$mapPromise.then(this.onInitedMap);
    }
};
</script>
<style lang="scss">
    #ecomotoriMap {
        .container {
            position: relative;
        }

        .poweredby {
            position: absolute;
            display: table-cell;
            text-align: center;
            top: 10px;

            & > div {
                width: 150px;
                margin: auto;
                position: relative;
                background-color: #ffffffa1;

                img {
                    width: 140px;
                    margin-bottom: 4px;
                }
            }
        }
    }

    @media only screen and (max-width: 1000px) {
        #ecomotoriMap {
            #nav-bar {
                #nav-reporting {
                    display: none;
                }
                #fuel-select {
                    top: 60px;
                    background: white;
                    left: 0px;
                    text-align: center;
                    padding-bottom: 8px;
                }
                #nav-buttons {
                    width: 100%;
                    position: relative;
                    box-shadow: 0px 0px 0px transparent;
                    border-bottom: 1px solid #f0f0f0;
                    right: 0px;
                    top: 0px;
                    border-radius: 0px;
                }
            }
            .vue-progress-path {
                top: 90px;
            }
            .panel-body {
                .vue-progress-path {
                    top: -16px;
                }
            }
        }
    }

    @media only screen and (max-width: 620px) {
        #ecomotoriMap {
            #nav-bar {
                #nav-reporting {
                    display: none;
                }
                #fuel-select {
                    top: 60px;
                    background: white;
                    left: 0px;
                    text-align: center;
                    padding-bottom: 8px;
                }
                #nav-buttons {
                    width: 100%;
                    position: relative;
                    box-shadow: 0px 0px 0px transparent;
                    border-bottom: 1px solid #f0f0f0;
                    right: 0px;
                    top: 0px;
                    border-radius: 0px;
                    span {
                        display: none;
                    }
                    &>button {
                        img {
                            margin-left: 5px;
                            margin-right: 5px;
                        }
                    }
                }
            }
            .vue-progress-path {
                top: 90px;
            }
            .panel-body {
                .vue-progress-path {
                    top: -16px;
                }
            }
            .side-bar {
                zoom: 0.9;
            }
        }
    }

    @media only screen and (max-width: 360px) {
        #ecomotoriMap {
            #nav-bar {
                height: 45px;
                #fuel-select {
                    top: 45px;
                    background: white;
                    left: 0px;
                    text-align: center;
                    padding-bottom: 8px;
                }
                #nav-reporting {
                    display: none;
                }
                #nav-buttons {
                    width: 100%;
                    position: relative;
                    box-shadow: 0px 0px 0px transparent;
                    border-bottom: 1px solid #f0f0f0;
                    right: 0px;
                    top: 0px;
                    border-radius: 0px;
                    height: 45px;
                    span {
                        display: none;
                    }
                    &>button {
                        img {
                            margin-left: 5px;
                            margin-right: 5px;
                        }
                    }
                }
            }
            .vue-progress-path {
                top: 75px;
            }
            .panel-body {
                .vue-progress-path {
                    top: -16px;
                }
            }
            .side-bar {
                zoom: 0.7;
            }
        }
    }

    // Slideout panel style
    #ecomotoriMap {
        .slideout-panel {
            position: absolute;
            height: 100%;
            width: 100%;
            .slideout-wrapper {
                position: absolute;
                height: 100%;
                width: 100%;
                .slideout {
                    position: absolute;
                    overflow: hidden;
                }
            }
        }
    }

    #nav-bar {
        position: relative;
        height: 60px;
        top: 0px;
        width: 100%;
        max-width: 1280px;
        margin: auto;
        #nav-reporting {
            float: left;
            font-size: 10px;
            text-decoration: underline;
            text-transform: uppercase;
            line-height: 60px;
            margin-left: 20px;
            cursor: pointer;
        }
        #nav-buttons {
            position: absolute;
            height: 65px;
            top: 10px;
            right: 10px;
            background: white;
            border-radius: 8px;
            z-index: 150;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
            & > button {
                border: 0px;
                height: 100%;
                background: none;
                img {
                    margin-left: 10px;
                    margin-right: 10px;
                }
                span {
                    font-size: 12px;
                    font-weight: bold;
                    text-transform: uppercase;
                    line-height: 12px;
                    text-align: left;
                    max-width: 70px;
                    display: block;
                    margin-right: 10px;
                    color: #2c3e50;
                }
                &.nav-separator {
                    border-right: 2px solid lightgray;
                }
            }
        }
    }
    #fuel-select {
        position: absolute;
        z-index: 90;
        width: 100%;
        top: 10px;
        left: 20px;
        text-align: left;
        label {
            display: inline-block;
        }
        .field-wrap {
            display: inline-block;
            select {
                margin-left: 5px;
                border: 1px solid lightgray;
                background: white;
                height: 20px;
            }
        }
    }
    #eco-map {
        .gm-style-iw {
            left: 0px !important;
        }
    }
    .marker {
        height: 40px;
        width: 40px;
        background-size: contain;
        position: relative;
        &.region {
          p {
            line-height: 50px;
          }
            height: 50px;
            width: 50px;
        }
        &.province {
          p {
            line-height: 50px;
          }
            height: 50px;
            width: 50px;
        }
        &.station {
            height: 55px;
            p {
                background-color: white;
                background-size: contain;
                height: 30px;
                width: 30px;
                display: block;
                margin: 5px 5px;
                position: absolute;
            }
        }
        &.waypoint {
            height: 55px;
        }
        p {
            line-height: 40px;
            color: white;
            font-weight: bold;
            font-size: 20px;
            margin: 0px;
        }
    }
    .marker-info {
        text-align: left;
        & > p {
            margin: 0px;
        }
        & > button {
            margin-top: 20px;
            border: none;
            text-transform: uppercase;
            padding: 6px;
            border: 1px solid;
            background: #515151;
            font-weight: bold;
            color: white;
            width: 100%;
        }
        p.country-title {
            text-transform: uppercase;
            font-weight: bold;
            font-size: 16px;
            color: #0c71b2;
            margin-left: 8px;
        }
        p.country-address {
            margin-left: 8px;
        }
        table {
            margin-top: 2px;
            width: 150px;
            border-spacing: 0px;
            td {
                border: 0px solid;
                font-weight: bold;
                padding: 4px 8px 4px 8px;
            }
            td.value {
                text-align: right;
                font-weight: bold;
                width: 100%;
            }
            tr.station {
                background: #f3f3f3;
            }
        }
    }
    .vue-progress-path {
        position: absolute;
        top: 47px;
        z-index: 120;
        path {
            stroke-width: 12;
        }
        .progress {
            stroke: #0c71b2;
        }
        .background {
            stroke: #edd;
        }
    }
    .panel-body {
        .vue-progress-path {
            position: relative;
            top: -16px;
        }
    }

    .cluster {
        & > img {
            height: 100%;
            width: 100%;
        }
        & > div {
            font-size: 16px !important;
        }
    }

    .side-bar {
        position: absolute;
        left: 0px;
        z-index: 50;
        width: 110px;
        text-align: left;
        top: calc(50% - 190px);
        & > button {
            text-align: center;
            text-transform: uppercase;
            border: 0px;
            min-height: 90px;
            width: 105px;
            background: white;
            border-radius: 0px 8px 8px 0px;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
            margin-bottom: 5px;
            padding: 5px;
            &:hover {
                width: 110px;
            }
            img {
                display: block;
                margin: auto;
            }
            span {
                display: block;
                font-weight: bold;
                font-size: 10px;
                color: #0c71b2;
                &.country-label {
                    font-size: 12px;
                    color: #525252;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
    }
</style>
